import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-71aff6ae"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "md:bg-background-medium max-h-screen flex py-0 sm:py-8 p-8 flex-col w-full md:w-2/6 page-height break-all" }
const _hoisted_2 = { class: "flex flex-col justify-between pb-4" }
const _hoisted_3 = { class: "flex justify-between flex-row lg:flex-col" }
const _hoisted_4 = {
  key: 0,
  class: "md:mt-5 font-bold text-4xl"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_6 = { class: "w-10 flex justify-end" }
const _hoisted_7 = { class: "flex-col sm:flex-row flex md:block whitespace-nowrap overflow-scroll h-24 md:h-auto no-scrollbar h-full" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex flex-grow" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_button = _resolveComponent("base-button")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.user != null)
          ? (_openBlock(), _createElementBlock("h2", _hoisted_4, [
              _createTextVNode(_toDisplayString(_ctx.t(`profile.greeting`)), 1),
              _hoisted_5,
              _createTextVNode(_toDisplayString(_ctx.user.given_name || _ctx.user.name) + "!", 1)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_base_button, {
            class: "md:hidden block w-8 h-8 bg-neutral-0 rounded-full flex justify-center",
            "on-click": _ctx.logout,
            "custom-style": "ghost-black",
            "icon-shown": true,
            "no-margin": true,
            "custom-icon": "logout"
          }, null, 8, ["on-click"])
        ])
      ]),
      _createElementVNode("section", _hoisted_7, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pages, (page, index) => {
          return (_openBlock(), _createBlock(_component_router_link, {
            key: index,
            to: page.link,
            class: "pr-4 md:pr-0",
            onClick: ($event: any) => (_ctx.changeActivePage(index))
          }, {
            default: _withCtx(() => [
              _createElementVNode("p", {
                class: _normalizeClass(`mt-4 sm:mt-8 text-lg w-auto ${page.linkIsActive ? 'text-accent-yellow font-bold' : ''}`)
              }, _toDisplayString(page.title), 3)
            ]),
            _: 2
          }, 1032, ["to", "onClick"]))
        }), 128))
      ])
    ]),
    _hoisted_8,
    _createVNode(_component_base_button, {
      class: "hidden md:flex md:border-t-2 border-white",
      text: _ctx.t('profile.logout'),
      "on-click": _ctx.logout,
      "custom-style": "ghost-black",
      "icon-shown": true,
      "custom-icon": "logout"
    }, null, 8, ["text", "on-click"])
  ]))
}